import { render, staticRenderFns } from "./JciYearList.vue?vue&type=template&id=fb2cbc50"
import script from "./JciYearList.vue?vue&type=script&lang=js"
export * from "./JciYearList.vue?vue&type=script&lang=js"
import style0 from "./JciYearList.vue?vue&type=style&index=0&id=fb2cbc50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports